







































import Vue, { PropType } from 'vue';
import { PeerGroupMembership } from '@/models/orgStructure';
import { BaseUser, MemberRole } from '../models';

import OrganizationUserCard from '@/components/OrganizationUserCard.vue';

export default Vue.extend({
  components: {
    OrganizationUserCard
  },

  props: {
    user: {
      type: Object as PropType<BaseUser>,
      required: true
    },

    roles: {
      type: Array as PropType<MemberRole[]>,
      required: true
    },

    showOrgWarning: {
      type: Boolean,
      required: false,
      default: false
    },

    memberships: {
      type: Array as PropType<PeerGroupMembership[]>,
      required: false
    },

    navDisabled: {
      type: Boolean,
      default: false
    },

    archived: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    prettyRoles(): string[] {
      return this.roles.map(r => MemberRole[r]);
    }
  },

  methods: {
    userClick() {
      if (this.navDisabled) {
        return;
      }

      const orgId = this.$route.params['organizationId'] as string;
      this.$router.push({
        name: 'OrganizationUser',
        params: { organizationId: orgId, userId: `${this.user.userId}` }
      });
    }
  }
});
